"use client";

import Image from "next/image";

import { useState } from "react";

import { Modal } from "@/components/Util/Modal";
import {
  Carousel,
  CarouselContent,
  CarouselDots,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";

type Props = {
  profileCarouselImages: string[];
  modalTitle: string;
};

export function ProfileCarousel({ profileCarouselImages, modalTitle }: Props) {
  const [showModal, setShowModdal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  function createModalCarouselElements() {
    return profileCarouselImages.map((pimage, index) => (
      <CarouselItem
        key={`carousel-item-modal-${pimage}`}
        className="relative h-[500px] basis-full"
      >
        <Image
          src={pimage}
          fill
          sizes="100vw"
          className="object-contain"
          alt={`${modalTitle} ${index + 1}`}
        />
      </CarouselItem>
    ));
  }

  function openModal(index: number) {
    setCurrentIndex(index);
    setShowModdal(true);
  }

  function ModalCarousel({ index }: { index: number }) {
    return (
      // Da prev/next absolut sind brauchen wir hier extra padding damit die nicht aus dem modal geschoben werden
      // padding items/pfeile + margin items/pfeile + Breite Pfeil
      <div className="relative px-[calc(4rem+42px)]">
        <Carousel
          opts={{
            align: "start",
            loop: true,
            startIndex: index,
          }}
          className="mb-12 w-full pb-2"
        >
          <CarouselPrevious />
          <CarouselContent >
            {createModalCarouselElements()}
          </CarouselContent>
          <CarouselNext />
          <CarouselDots />
        </Carousel>
      </div>
    );
  }

  return (
    <>
      <Carousel
        opts={{
          align: "start",
          loop: true,
        }}
        plugins={[
          Autoplay({
            delay: 5000,
          }),
        ]}
        // x * 216px + (x-1) * 16px
        className="mx-auto mb-6 w-[232px] max-w-[696px] sm:w-[464px] md:w-[696px] lg:mr-2"
      >
        <CarouselContent className="">
          {profileCarouselImages.map((pimage, index) => (
            <CarouselItem
              key={`carousel-item-${pimage}`}
              className="basis-full sm:basis-1/2 md:basis-1/3"
            >
              <button
                className="h-[150px] rounded-lg bg-babyBlue p-0 outline-none hover:scale-95 hover:bg-slate-200"
                type="button"
                onClick={() => openModal(index)}
              >
                <Image
                  src={pimage}
                  width={200}
                  height={150}
                  className="m-0 rounded-lg object-contain"
                  alt={`${modalTitle} ${index + 1}`}
                />
              </button>
            </CarouselItem>
          ))}
        </CarouselContent >
        <CarouselDots className="scale-75 -ml-3" />
      </Carousel>
      <Modal
        header={modalTitle}
        open={showModal}
        modalDidClose={() => setShowModdal(false)}
        disableOverflow
      >
        <ModalCarousel index={currentIndex} />
      </Modal>
    </>
  );
}
